import { t } from '../i18n';
import { ApiError } from './api';

/** Mensaje para mostrar al usuario a partir de un error de la API. */
export function errorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.status === 429) return t('login.demasiados_intentos');
    if (err.status >= 500) return t('comun.error_inesperado');
    return err.message;
  }
  return t('comun.error_inesperado');
}
